import { Locale, type LocalizedString } from "../Locale.js";
import type { Tenant } from "../Tenant.js";
import { getPathInLocale } from "./getPathInLocale.js";

const pathMap = {
	[Locale.cs]: "/ucet/adresy" as const,
	[Locale.en]: "/account/deliveryAddresses" as const,
} satisfies LocalizedString;

export function getCustomerAddressesPath(tenant: Tenant): string {
	return getPathInLocale(tenant.locale, pathMap);
}
